module.exports = __webpack_public_path__ + "img/w3_spinner_white.613d434c.613d434c.png";